// eslint-disable-next-line @alltrails/custom/use-client
'use client';

// eslint-disable-next-line @alltrails/custom/use-client
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from './SponsoredBadge.module.scss';

type SponsoredBadgeProps = {
  className?: string;
};

export default function SponsoredBadge({ className }: SponsoredBadgeProps) {
  return (
    <div className={className}>
      <Typography className={styles.sponsored} variant="text50bold" component="span">
        {/* eslint-disable-next-line @alltrails/custom/use-client */}
        <FormattedMessage defaultMessage="Sponsored" />
      </Typography>
    </div>
  );
}
